// delReports/slice.js

import { activeDelReportingInitialState } from "./activeDelsDelReportsState";
import { makeActiveDelReportingActions } from "./activeDelsDelReportsActions";

export const createActiveDelReportingSlice = (set, get) => ({
  activeDelReporting: activeDelReportingInitialState,
  activeDelReportingActions: Object.freeze(
    makeActiveDelReportingActions(set, get)
  ),
});
